import actionTypes from "../actions/actionTypes";
import * as storage from "../coraWebComponents/utils/storage";

const user = (
  state = {
    isLoading: false,
    data: storage.getUser(),
    userMessage: null,
  },
  action
) => {
  switch (action.type) {
    case actionTypes.SIGN_IN_REQUEST:
    case actionTypes.LOGIN_REQUEST:
    case actionTypes.LOGIN_OAUTH_REQUEST:
    case actionTypes.CREATE_USER_REQUEST:
    case actionTypes.VERIFY_EMAIL_AND_PASS_REQUEST:
    case actionTypes.REFRESH_USER_REQUEST:
    case actionTypes.FORGOT_PASSWORD_REQUEST:
    case actionTypes.UPDATE_USER_REQUEST:      
      return { ...state, isLoading: true };

    case actionTypes.REFRESH_USER_SUCCESS:
      return { isLoading: false, data: storage.getUser() };

    case actionTypes.SIGN_IN_SUCCESS:
    case actionTypes.LOGIN_SUCCESS:
    case actionTypes.LOGIN_OAUTH_SUCCESS:
      return { isLoading: false, data: action.res.Data };

    case actionTypes.VERIFY_EMAIL_AND_PASS_SUCCESS:
    case actionTypes.VERIFY_EMAIL_AND_PASS_FAILURE:
    case actionTypes.CREATE_USER_SUCCESS:
    case actionTypes.CREATE_USER_FAILURE:
    case actionTypes.UPDATE_USER_SUCCESS:
    case actionTypes.UPDATE_USER_FAILURE:      
      return { ...state, isLoading: false };

    case actionTypes.SIGN_IN_FAILURE:
    case actionTypes.REFRESH_USER_FAILURE:
    case actionTypes.LOGIN_FAILURE:
    case actionTypes.LOGIN_OAUTH_FAILURE:
      return { isLoading: false, data: null };

    case actionTypes.SIGN_OUT:
      storage.removeUser();
      return { isLoading: false, data: null, userMessage: null };

    case actionTypes.FORGOT_PASSWORD_SUCCESS:
      return { ...state, isLoading: false, userMessage: action.res.UserMessage };

    case actionTypes.FORGOT_PASSWORD_FAILURE:
       return { ...state, isLoading: false, userMessage: null };

    default:
      return state;
  }
};

export default user;
